import { z } from 'zod';
/**
 * Discriminator for the FeatureValue / FeatureValidation / FeatureDef union.
 * Numeric values match the feature_types table (typeId column on Features).
 */
export var FeatureType;
(function (FeatureType) {
    FeatureType[FeatureType["Boolean"] = 1] = "Boolean";
    FeatureType[FeatureType["String"] = 2] = "String";
    FeatureType[FeatureType["Number"] = 3] = "Number";
    FeatureType[FeatureType["Markdown"] = 4] = "Markdown";
    FeatureType[FeatureType["MultiSelect"] = 5] = "MultiSelect";
    FeatureType[FeatureType["Json"] = 6] = "Json";
    FeatureType[FeatureType["StringList"] = 7] = "StringList";
})(FeatureType || (FeatureType = {}));
/**
 * Canonical scope_type identifier used everywhere a feature's scope is
 * referenced (areas, surfacedIn, override adapters, audit rows). Do NOT
 * introduce a parallel ScopeType - extend this enum instead.
 */
export const FeatureAreaSchema = z.enum([
    'agent',
    'application',
    'brand',
    'account',
    'group',
    'module',
    'data-connection',
    'user',
]);
